import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { decryptData } from "../utils/storageCrypto";

/**
 * Authentication guard for Delivery Partner
 * Checks localStorage for deliveryPartner object
 * Redirects to login if missing or invalid
 */
const useAuthenticationCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const enstoredPartner = localStorage.getItem("deliveryPartner");

      const storedPartner = decryptData(enstoredPartner);

      if (!storedPartner) {
        navigate("/delivery", { replace: true });
        return;
      }

      const parsedPartner = JSON.parse(storedPartner);

      // Basic integrity check (adjust keys if needed)
      if (!parsedPartner?.id || !parsedPartner?.token) {
        localStorage.removeItem("deliveryPartner");
        navigate("/delivery", { replace: true });
      }
    } catch (error) {
      console.error("Authentication check failed:", error);
      localStorage.removeItem("deliveryPartner");
      navigate("/delivery", { replace: true });
    }
  }, [navigate]);
};

export default useAuthenticationCheck;
